import { type AppState, Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import { useRouter } from "next/router";
import { type FC, type PropsWithChildren, useCallback, useEffect } from "react";

import { authenticationActorRef } from "~/state/machines/authentication";

import { getAuthConfigs } from "./authconfig";
import { getAuthURLs } from "./interop/common";
import { onLoginSuccess } from "./loginAction";

export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
	const router = useRouter();

	const authConfig = getAuthConfigs(process.env.AUTH_ENV);
	const { loginRedirectUri } = getAuthURLs(process.env.APP_ENV);

	const onRedirectCallback = useCallback(
		(appState: AppState | undefined) => {
			if (appState) {
				const returnTo = onLoginSuccess(appState["redirectId"]);
				if (returnTo) {
					void router.replace({ query: {}, pathname: returnTo }, undefined, {
						shallow: true,
					});
				}
			}
		},
		[router]
	);

	return (
		<Auth0Provider
			domain={authConfig.auth0Domain}
			clientId={authConfig.auth0ClientId}
			authorizationParams={{ redirect_uri: loginRedirectUri, audience: authConfig.audience }}
			onRedirectCallback={onRedirectCallback}
			cacheLocation={"localstorage"}
			useRefreshTokens
		>
			{children}

			<AccessTokenInjector />
		</Auth0Provider>
	);
};

export type GetAccessTokenSilently = (opts?: {
	promptForLogin?: boolean;
	redirectPath?: string;
}) => Promise<string | undefined>;

const AccessTokenInjector = () => {
	const { getAccessTokenSilently, isAuthenticated, loginWithRedirect, logout, user } = useAuth0();

	useEffect(() => {
		// console.log("AUTHN", {
		// 	isAuthenticated,
		// 	user,
		// 	loginWithRedirect,
		// 	logout,
		// 	getAccessTokenSilently,
		// });
		authenticationActorRef.send({
			type: "context.receivedAuth0StateUpdate",
			isAuthenticated,
			user,
			loginWithRedirect,
			logout,
			getAccessTokenSilently,
		});
	}, [getAccessTokenSilently, isAuthenticated, loginWithRedirect, logout, user]);

	return null;
};
